"use client";

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { useHotelsSearch } from "@lib/context/hotels/search-context";
import { useMobileFilters } from "@lib/context/mobile/filters-context";
import HotelsDestinationAutocompleteInput from "@modules/hotels/shared/inputs-bar/components/destination-autocomplete-input";
import { MuscleButton } from "@modules/shared/components/buttons";
import useCssModules from "@lib/hooks/use-css-modules";
import { usePathname } from "next/navigation";

// Import the validation type

export const HotelsDestinationSelection = () => {
  const t = useTranslations("Shared");
  const {
    setNode
  } = useForwardNode();
  const {
    togglePanel
  } = useSideOverPanel();
  const {
    search,
    setSearch,
    destinationSelection,
    setDestinationSelection,
    clearDestination
  } = useHotelsSearch();
  const {
    hotelsFilters
  } = useMobileFilters();
  const pathname = usePathname();
  const {
    cssModules
  } = useCssModules();
  const {
    destinationSelectionApplyButton,
    destinationSelectionCancelButton,
    destinationSelectionApplyButtonContainer,
    destinationSelectionPanelContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.DestinationSelection) || {};

  // Get the current hotel search from context or use a default
  const currentHotelSearch = search || {
    occupations: hotelsFilters.selectedOccupations,
    destination: {
      id: "",
      value: ""
    },
    dates: {
      check_in: new Date(),
      check_out: new Date()
    }
  };
  const {
    0: showValidation,
    1: setShowValidation
  } = useState(false);

  // Custom validation for destination selection step - only validates destination
  const validateDestinationSelection = destination => {
    if (!(destination !== null && destination !== void 0 && destination.id) || !(destination !== null && destination !== void 0 && destination.value)) {
      return {
        success: false,
        message: "Hotels.InputsBar.ERRORS.NO_DESTINATION_ERROR",
        field: "destination"
      };
    }
    return {
      success: true,
      message: "success",
      field: ""
    };
  };
  const {
    0: validation,
    1: setValidation
  } = useState(() => validateDestinationSelection(currentHotelSearch === null || currentHotelSearch === void 0 ? void 0 : currentHotelSearch.destination));

  // Initialize destinationSelection context if we have hotel search but no context value
  useEffect(() => {
    var _currentHotelSearch$d;
    if (!destinationSelection && currentHotelSearch !== null && currentHotelSearch !== void 0 && (_currentHotelSearch$d = currentHotelSearch.destination) !== null && _currentHotelSearch$d !== void 0 && _currentHotelSearch$d.id) {
      // Create an AutocompleteOption from the existing hotel search
      const existingDestination = {
        id: currentHotelSearch.destination.id,
        title: currentHotelSearch.destination.value || "",
        value: currentHotelSearch.destination
      };
      setDestinationSelection(existingDestination);
    }
  }, [currentHotelSearch, destinationSelection, setDestinationSelection]);

  // Update validation when destination selection changes
  useEffect(() => {
    const destination = destinationSelection === null || destinationSelection === void 0 ? void 0 : destinationSelection.value;
    const validation = validateDestinationSelection(destination);
    setValidation(validation);
  }, [destinationSelection]);
  const handleDestinationSelection = autocompleteOption => {
    if (autocompleteOption) {
      setDestinationSelection(autocompleteOption);

      // Also update the search state to keep everything in sync
      if (search) {
        const updatedDestination = {
          id: autocompleteOption.id,
          value: autocompleteOption.title
        };
        setSearch(_objectSpread(_objectSpread({}, search), {}, {
          destination: updatedDestination
        }));
      }
    } else {
      clearDestination();
    }
  };
  return __jsx("div", {
    className: destinationSelectionPanelContainer
  }, __jsx(HotelsDestinationAutocompleteInput, {
    onSelectOption: handleDestinationSelection,
    dataTestId: "destination-mobile",
    value: destinationSelection === null || destinationSelection === void 0 ? void 0 : destinationSelection.value,
    hasErrors: showValidation && validation.field === "destination",
    disable: false,
    customInputClass: "tx-plg-regular",
    className: "mobile-autocomplete-no-border",
    disableLabelAnimation: true,
    useBorderlessStyle: true
  }), showValidation && validation.field === "destination" && __jsx("p", {
    className: "mt-2 text-xs text-red-600 font-medium"
  }, t(validation.message)), __jsx("div", {
    className: destinationSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    variant: "solidXL",
    onClick: () => setNode("HotelsCalendarSelection"),
    disabled: !validation.success
  }, t("CONTINUE")), pathname.includes("/hotels/search") ? __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => setNode("EditHotelSelection")
  }, t("MAKE_CHANGES")) : __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => togglePanel()
  }, t("CANCEL"))));
};